import { pickFirstDefined, parseStepPosition, toPositiveInteger } from '../utils/object.js'

function normalizeStepTransitions(value) {
  if (!Array.isArray(value)) return []
  return value.filter(function (item) {
    return item && typeof item === 'object' && typeof item.key === 'string'
  }).map(function (item) {
    return {
      key: item.key,
      label: pickFirstDefined(item.label, item.key),
      mode: item.mode || null
    }
  })
}

function normalizeMissionEntity(value, fallbackCode) {
  if (!value) return null
  if (typeof value === 'string') {
    return {
      code: value,
      label: value,
      totalSteps: null,
      position: null
    }
  }
  if (typeof value !== 'object') return null

  return {
    code: pickFirstDefined(value.code, value.key, fallbackCode),
    label: pickFirstDefined(value.label, value.name, value.title, value.code, value.key, fallbackCode),
    marketingName: pickFirstDefined(value.marketingName, value.marketing, value.capabilityName),
    displayName: pickFirstDefined(value.displayName, value.display, value.marketingDisplayName),
    totalSteps: toPositiveInteger(pickFirstDefined(value.totalSteps, value.totalStepsCount, value.stepsTotal, value.stepTotal, value.stepsCount)),
    position: parseStepPosition(pickFirstDefined(value.position, value.stepPosition, value.order, value.index)),
    previous: value.previous,
    next: normalizeStepTransitions(pickFirstDefined(value.next, value.stepNext, value.activeStepNext))
  }
}

function normalizeMissionState(result) {
  if (!result || typeof result !== 'object') return null

  var mode = result.mode || null
  var activeSkillValue = result.activeSkill || result.skill || result.skillInfo || result.skillDetails || result.skillMeta || result.skillData
  var activeStepValue = result.activeStep || result.step || result.stepInfo || result.stepDetails || result.stepMeta || result.stepData
  var activeSkill = normalizeMissionEntity(activeSkillValue, result.skillKey)
  var activeStep = normalizeMissionEntity(activeStepValue, result.stepKey)

  if (!activeSkill && result.skillKey) {
    activeSkill = normalizeMissionEntity(result.skillKey, result.skillKey)
  }
  if (!activeStep && result.stepKey) {
    activeStep = normalizeMissionEntity(result.stepKey, result.stepKey)
  }

  if (activeSkill && !activeSkill.totalSteps) {
    activeSkill.totalSteps = toPositiveInteger(pickFirstDefined(
      result.totalSteps,
      result.stepsTotal,
      result.skillTotalSteps,
      result.skillStepsTotal,
      result.stepTotal,
      result.stepsCount
    ))
  }

  if (activeStep && !activeStep.position) {
    activeStep.position = parseStepPosition(pickFirstDefined(
      result.stepPosition,
      result.stepIndex,
      result.position,
      result.order
    ))
  }

  if (activeStep) {
    activeStep.next = normalizeStepTransitions(
      pickFirstDefined(
        activeStep.next,
        result.next,
        result.stepNext,
        result.activeStepNext,
        result.stepResult && result.stepResult.next
      )
    )
  }

  var activeSkillEnd = pickFirstDefined(
    activeSkillValue && activeSkillValue.end,
    result.end
  )

  return {
    mode: mode,
    activeSkill: activeSkill
      ? Object.assign(activeSkill, {
          end: Array.isArray(activeSkillEnd) ? activeSkillEnd : undefined
        })
      : null,
    activeStep: activeStep
  }
}

function normalizeNewSkillState(data) {
  if (!data || typeof data !== 'object') return null

  var activeSkill = {
    code: data.code || data.skillKey || data.key || 'MISSION',
    label: data.label || data.name || data.code || data.skillKey || 'Agent',
    marketingName: data.marketingName || data.marketing || data.capabilityName,
    displayName: data.displayName || data.display || data.marketingDisplayName,
    totalSteps: toPositiveInteger(data.totalSteps),
    position: null,
    next: []
  }

  return {
    mode: 'routing-skill',
    activeSkill: activeSkill,
    activeStep: null
  }
}

export { normalizeMissionState, normalizeNewSkillState }
